import { Component, OnInit, Input, SimpleChanges, OnChanges, OnDestroy } from '@angular/core';
import { FeeService } from '@app/services/fees/fee.service';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';
import { Subscription } from 'rxjs';
import { DatePipe } from '@angular/common';
import { CSVDataService } from '@app/export/CSVDataService';
import { FormBuilder, Validators } from '@angular/forms';
import { ConfirmationService, MessageService, SelectItem } from 'primeng/api';
import { PermissionsService } from '@app/services/permissions/permissions.service';


interface MemberShort {
  memberId: number;
  givenName: string;
  familyName: string;
}

interface LodgeAndCamp {
  id: number;
  shortName: string;
  name: string;
}

interface Payment {
  isFullyPaid: boolean;
  paidDate: string;
  paidAmount: number;
  totalPaidAmount: number;
  totalAmountToPay: number;
  payPercentage: number;
}

interface MemberPayments {
  paymentId: number;
  memberId: number;
  givenName: string;
  familyName: string;
  payments: Payment[];
}

interface MemberFee {
  memberFeeId: number;
  memberId: number;
  givenName: string;
  familyName: string;
  primaryInstitution: IPrimaryinstitution;
  institutionId: number;
  startDate: string;
  endDate: string;
  payPercentage: number;
  feeAfterDiscount: number;
}

interface IPrimaryinstitution {
  id: number;
  shortName: string;
}
@Component({
  selector: 'app-nedsattning',
  templateUrl: './nedsattning.component.html'
})
export class NedsattningComponent implements OnInit, OnChanges, OnDestroy {
  @Input() institution: LodgeAndCamp;
  @Input() year: number;
  memberlist: MemberShort[] = [];
  memberslist: SelectItem[] = [];
  memberpayments: MemberPayments[] = [];
  memberfees: MemberFee[] = [];
  minmaxyear = { minYear: '1920', maxYear: '2100' };
  autoCorrectedDatePipe = createAutoCorrectedDatePipe('yyyy-mm', this.minmaxyear);
  public maskdatumshort = [/[129]/, /[?09]/, /\d/, /\d/, '-', /\d/, /\d/];
  subscriptions: Subscription[] = [];
  cols: any[];
  rowdata;
  result;
editview = false;
form;

annualamount;
selectedMember;
roleid;
edit_memfee;

  constructor(private fb: FormBuilder, private feeService: FeeService, private confirmationService: ConfirmationService, private datePipe: DatePipe, private messageService: MessageService, private permissionService: PermissionsService) { }

  ngOnInit() {
    this.form = this.fb.group({
      memberId: ['', Validators.required],
      institutionId: [null, null],
      startDate: ['', Validators.required],
      endDate: ['', ''],
      payPercentage: ['', ''],
      feeAfterDiscount: ['', '']
    });
    
    this.permissionService.selectedrole.subscribe(r => {
      this.roleid = r.roleId;
      this.edit_memfee = r.permissions.includes('EDIT_MEMFEE');
    });
    this.form.patchValue({institutionId: this.institution.id.toString()});

    this.subscriptions.push(this.feeService.getPaidFees(this.institution.id, this.year).subscribe(response => {
      this.memberpayments = response;
      if (this.memberpayments) {
        this.generateMemberlist();
      }
    }));

    this.subscriptions.push(this.feeService.getFees(this.institution.id).subscribe(response => {
      if (response) {
        const idx = response.findIndex(r => {
          return r.year === this.year
        });
        this.annualamount = response[idx]?.fee;
      }
    }));

    this.subscriptions.push(this.feeService.getMemberFees(this.institution.id, this.year).subscribe(response => {
      this.memberfees = response;

      this.memberfees.forEach(m => {
        m.startDate = this.datePipe.transform(m.startDate, 'yyyy-MM');
        m.endDate = this.datePipe.transform(m.endDate, 'yyyy-MM');
                 m['institutionId'] = m.primaryInstitution.id;
          m['shortName'] = m.primaryInstitution.shortName;


      });

    }));

    this.cols = [

      { field: 'memberId', header: 'Medlemsid' },
      { field: 'givenName', header: 'Förnamn' },
      { field: 'familyName', header: 'Efternamn' },
      { field: 'shortName', header: 'Inst.'},
      { field: 'startDate', header: 'Från datum'},
      { field: 'endDate', header: 'Till datum'},
      { field: 'annualAmount', header: 'Årsavgift'},
      { field: 'payPercentage', header: '%'}
      ];
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => {
      sub.unsubscribe();
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes) {
      this.ngOnInit();
    }
   // this.ngOnInit();
  }

  checkPercent(evt) {

    if (evt.target.value > 100) {
      this.form.patchValue({payPercentage: null});
      this.messageService.add({severity:'warn', summary:'Information', detail:'Procentsatsen får inte vara över 100'});
    }
  }
  generateMemberlist() {

    this.memberlist = [];

    this.memberpayments.forEach(payment => {
      const member = {
        memberId: payment.memberId,
        givenName: payment.givenName,
        familyName: payment.familyName
      };
      this.memberlist.push(member);
    });
    this.memberslist = [{label: null, value: null}];
    this.memberpayments.forEach(p => {
      this.memberslist.push({ label: p.memberId + ' ' + p.givenName + ' ' + p.familyName, value: p.memberId });
    });

  }

  setSingleMember(evt) {
    this.form.patchValue({memberId: evt.value});

  }

  setMemberId(evt: any) {

  }

  close(evt) {

    this.editview = false;
  }

  save(evt) {

    const data = {
      memberId: evt.memberId,
      institutionId: this.institution.id,
      startDate: evt.startDate,
      endDate: evt.endDate,
      payPercentage: evt.payPercentage,
      memberFeeId: evt.memberFeeId,
      action: 'update' //delete
    };
    this.feeService.AddMemberFee(data).subscribe(resp => {
      if (resp) {

      this.ngOnInit();
      }
    });
    this.editview = false;
  }

  add() {
    const data = {
      memberId: this.form.get('memberId').value,
      institutionId: this.institution.id,
      startDate: this.form.get('startDate').value,
      endDate: this.form.get('endDate').value,
      payPercentage: this.form.get('payPercentage').value,
      action: 'add'
    };
    const discountdata = {
      memberId: data.memberId,
      institutionId: data.institutionId,
      startDate: data.startDate,
      endDate: data.endDate
    };
    this.feeService.UserHasFeeDiscount(discountdata).subscribe(resp =>  {
      if (resp === true) {
        this.showInfoDialog();
      } else {
        this.feeService.AddMemberFee(data).subscribe(resp => {
          if (resp) {
          this.ngOnInit();
          }
        });
      }
    });
  }

  editRow(row) {
    this.rowdata = row;
    this.editview = true;
  }

  exportToCSV() {
    const firstrow = 'Medlemsid;Förnamn;Efternamn;Primärinstitution;Startdatum;Slutdatum;Procentsats;Årsavgift';
    const filnamn = 'OF_Nedsättningar';
    let data = [];
    this.memberfees.forEach(f => {

      const row = {
        memberId: f.memberId,
        givenName: f.givenName,
        familyName: f.familyName,
        shortName: f.primaryInstitution.shortName,
        startDate: this.datePipe.transform(f.startDate, 'yyyy-MM'),
        endDate: this.datePipe.transform(f.endDate, 'yyyy-MM'),
        payPercentage: f.payPercentage,
        feeAfterDiscount: f.feeAfterDiscount
      }

      data.push(row);
    });

    CSVDataService.exportToCsv(filnamn + '.csv', data, firstrow);
  }


  showInfoDialog(): void {
    this.confirmationService.confirm({
      header: 'Information',
      message: 'Vänligen avsluta befintlig nedsättning för vald medlem med överlappande datum innan ytterligare nedsättning registreras.',
      acceptLabel: 'Ok',
      rejectVisible: false,
      accept: () => {
         
      },
      reject: () => {
      }
    });

  }

  deleteRow(rowData) {

    this.confirmDialog(rowData);
  }

  confirmDialog(rowdata): void {
     this.confirmationService.confirm({
      header: 'Bekräftelse',
      message: 'Vill du radera nedsättning för ' + rowdata.givenName + ' ' +  rowdata.familyName + '?',
      acceptLabel: 'Ja',
      rejectLabel: 'Nej',
      accept: () => {
         this.delete(rowdata);
      },
      reject: () => {
      }
    });
  }

  delete(rowdata) {

    const data = {
      memberId: rowdata.memberId,
      institutionId: this.institution.id,
      startDate: rowdata.startDate,
      endDate: rowdata.endDate,
      payPercentage: rowdata.payPercentage,
      memberFeeId: rowdata.memberFeeId,
      action: 'delete'
    };
    this.feeService.AddMemberFee(data).subscribe(resp => {
      if (resp) {
        this.messageService.add({severity:'success', summary:'Information', detail:'Nedsättning raderad.'});
      this.ngOnInit();
      }
    });

  }

}
